import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Link, useLocation } from "react-router-dom";

// question and emoji space
// bigger emoji spacing between the emoji
// sad face -> confused emoji
// emoji is not rendering

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  input: {
    width: "100%",
    height: 40,
    marginBottom: 40,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  submitbutton: {
    width: "100%",
    height: 40,
    backgroundColor: "lightgreen",
    border: "0",
    marginBottom: 20,
  },
  danger: {
    alignItems: "center",
    justifyContent: "center",
    color: "red",
  },
}));

export default function Form(props) {
  const location = useLocation();
  const [visibility, setVisibility] = useState(true);
  const [formData, setFormData] = useState({
    email: "",
    organisation: "/org" + location.pathname,
  });

  const { email } = formData;
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [error, setError] = useState(false);
  const classes = useStyles();
  const rootRef = React.useRef(null);
  const onSubmit = async (e) => {
    setVisibility(false);
    props.quizformsubmit(email);
    e.preventDefault();
    try {
      let ans1 = "";
      let ans2 = "";
      let ans3 = "";
      let ans4 = "";
      let ans5 = "";
      let ans6 = "";
      let ans7 = "";
      let ans8 = "";
      let ans9 = "";
      let ans10 = "";
      let ans11 = "";
      if (props.mcq1 == 0) {
        ans1 = "Everyone!";
      } else if (props.mcq1 == 1) {
        ans1 = "Most people except support staff";
      } else if (props.mcq1 == 2) {
        ans1 = "Functional leaders, managers and team leads";
      } else if (props.mcq1 == 3) {
        ans1 = "Only leaders";
      } else if (props.mcq1 == 4) {
        ans1 = "No one";
      }
      if (props.mcq2 == 0) {
        ans2 = "Oh Yeah - everyone can see everyone's goals";
      } else if (props.mcq2 == 1) {
        ans2 = "It's a mix - most are visible, some are confidential";
      } else if (props.mcq2 == 2) {
        ans2 = "They're only visibly to our team members";
      } else if (props.mcq2 == 3) {
        ans2 = "Only my own and my manager's goals are visible";
      } else if (props.mcq2 == 4) {
        ans2 = "I can just see my own goals";
      }
      if (props.mcq3 == 0) {
        ans3 = "Half-yearly or annually";
      } else if (props.mcq3 == 1) {
        ans3 = "Quarterly";
      } else if (props.mcq3 == 2) {
        ans3 = "Monthly";
      } else if (props.mcq3 == 3) {
        ans3 = "Fortnightly";
      } else if (props.mcq3 == 4) {
        ans3 = "Weekly";
      }
      if (props.mcq4 == 0) {
        ans4 = "PPTs or Spreadsheets";
      } else if (props.mcq4 == 1) {
        ans4 = "Goal-tracking/OKR platforms";
      } else if (props.mcq4 == 2) {
        ans4 = "Different tools like ERP, CRM, HRMS, etc.";
      } else if (props.mcq4 == 3) {
        ans4 = "We don't use a specific tool or platform";
      }
      if (props.mcq5 == 0) {
        ans5 = "Once a year";
      } else if (props.mcq5 == 1) {
        ans5 = "Annual and mid-year check-ins";
      } else if (props.mcq5 == 2) {
        ans5 = "Quarterly check-ins";
      } else if (props.mcq5 == 3) {
        ans5 = "Monthly!";
      } else if (props.mcq5 == 4) {
        ans5 = "It's up to the manager to decide";
      }
      if (props.mcq6.checkedA) {
        ans6 = "Energy, emotions, engagement ,";
      }
      if (props.mcq6.checkedB) {
        ans6 += "Actions, updates, obstacles ,";
      }
      if (props.mcq6.checkedC) {
        ans6 += "Growth & development ,";
      }
      if (props.mcq6.checkedD) {
        ans6 += "Performance feedback ,";
      }
      if (props.mcq6.checkedE) {
        ans6 += "Business KPIs ,";
      }

      if (props.mcq7.checkedA) {
        ans7 = "Annually during performance appraisal/360 feedback ,";
      }
      if (props.mcq7.checkedB) {
        ans7 += "End-of-projects reviews ,";
      }
      if (props.mcq7.checkedC) {
        ans7 += "Monthly team meetings ,";
      }
      if (props.mcq7.checkedD) {
        ans7 += "Weekly stand-ups/planning meetings ,";
      }
      if (props.mcq7.checkedE) {
        ans7 += "Almost daily in the flow-of-work ,";
      }

      if (props.mcq8.checkedA) {
        ans8 = "Annual/semi-annual 360 surveys ,";
      }
      if (props.mcq8.checkedB) {
        ans8 += "Internal communication tools - email, chat, intranet, etc. ,";
      }
      if (props.mcq8.checkedC) {
        ans8 += "Separate feedback/recognition tool ,";
      }
      if (props.mcq8.checkedD) {
        ans8 += "Feedback/recognition window on performance platform ,";
      }

      if (props.mcq9.checkedA) {
        ans9 = "Develop, coach and grow people ,";
      }
      if (props.mcq9.checkedB) {
        ans9 += "Calculate ratings for increments & bonus ,";
      }
      if (props.mcq9.checkedC) {
        ans9 += "Identify good and poor performers ,";
      }
      if (props.mcq9.checkedD) {
        ans9 += "Identify and build people's strengths ,";
      }

      if (props.mcq10.checkedA) {
        ans10 = "Performance Ratings ,";
      }
      if (props.mcq10.checkedB) {
        ans10 += "Managers feedback ,";
      }
      if (props.mcq10.checkedC) {
        ans10 +=
          "Others feedback (peers, junior colleagues and cross-functional managers) ,";
      }
      if (props.mcq10.checkedD) {
        ans10 += "Growth from previous review cycles ,";
      }

      if (props.mcq11 == 0) {
        ans11 = "Spreadsheets  - Offline/online";
      } else if (props.mcq11 == 1) {
        ans11 = "In a Performance module in our HR management system";
      } else if (props.mcq11 == 2) {
        ans11 = "Combination of Goals/OKR platform and spreadsheets";
      } else if (props.mcq11 == 3) {
        ans11 = "Separate/ dedicated performance management system";
      }

      const response = await fetch(
        "https://mesh-okr-core-lead.mesh.ai/quizLead",
        {
          method: "POST",

          headers: {
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
            q1: ans1,
            q2: ans2,
            q3: ans3,
            q4: ans4,
            q5: ans5,
            q6: ans6,
            q7: ans7,
            q8: ans8,
            q9: ans9,
            q10: ans10,
            q11: ans11,
            contact: "no",
          }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        console.log(data);
        setVisibility(false);
      }
    } catch (err) {
      setError(true);
      console.log(err.message);
    }
  };
  if (visibility) {
    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
        aria-labelledby="server-modal-title"
        aria-describedby="server-modal-description"
        className={classes.modal}
        style={{ padding: "50px", backgroundColor: "rgba(0,0,0,0.9)" }}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
          <p id="server-modal-description" style={{ textAlign: "center" }}>
            <b>Enter your work email to get your result</b>
          </p>
          <form onSubmit={(e) => onSubmit(e)}>
            <input
              className={classes.input}
              type="email"
              name="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => onChange(e)}
              required
            ></input>
            <input
              type="submit"
              className={classes.submitbutton}
              value="Submit"
            />
          </form>
        </div>
      </Modal>
    );
  } else {
    return <div></div>;
  }
}
